import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Industries',
    path: '/industries'
  }, {
    name: 'Case Studies',
    path: '/case-studies'
  }, {
    name: 'Insights',
    path: '/insights'
  }, {
    name: 'Contact',
    path: '/contact'
  }, {
    name: 'Careers',
    path: '/careers'
  }];
  return <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-113">
      <div className="container mx-auto px-4 md:px-6" data-id="element-114">
        <div className="flex items-center justify-between" data-id="element-115">
          <Link to="/" className="flex items-center" data-id="element-116">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-117">
              <span className="text-toronto-blue font-display text-2xl md:text-3xl font-bold" data-id="element-118">
                Market Research
                <span className="text-canada-red" data-id="element-119"> Toronto</span>
              </span>
            </motion.div>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6" data-id="element-120">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-medium transition-colors duration-200 ${location.pathname === link.path ? 'text-toronto-blue border-b-2 border-toronto-blue' : 'text-neutral-dark hover:text-toronto-blue'}`} data-id="element-121">
                {link.name}
              </Link>)}
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden text-neutral-dark focus:outline-none" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-122">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-123" /> : <MenuIcon size={24} data-id="element-124" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="md:hidden mt-4" data-id="element-125">
            <div className="flex flex-col space-y-4 py-4 bg-white" data-id="element-126">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`px-4 py-2 font-medium ${location.pathname === link.path ? 'text-toronto-blue bg-neutral-light' : 'text-neutral-dark hover:text-toronto-blue'}`} onClick={() => setMobileMenuOpen(false)} data-id="element-127">
                  {link.name}
                </Link>)}
            </div>
          </motion.div>}
      </div>
    </header>;
};
export default Header;